import { createSlice } from '@reduxjs/toolkit';

export const SubscriptionDB = createSlice({
    name: 'subscription',
    initialState: {
        planName: '',
        duration: 1,
        frequency: '',
        trialPeriod: 0,
        price: 0,
        oem: true
    },
    reducers: {
        setPlanName: (state, action) => {
            return {
                ...state,
                planName: action.payload
            }
        },
        setDuration: (state, action) => {
            return {
                ...state,
                duration: Number(action.payload)
            }
        },
        setFrequency: (state, action) => {
            return {
                ...state,
                frequency: action.payload
            }
        },
        setPrice: (state, action) => {
            return {
                ...state,
                price: Number(action.payload)
            }
        },
        setTrialPeriod: (state, action) => {
            return {
                ...state,
                trialPeriod: Number(action.payload)
            }
        },
        setOem: (state, action) => {
            return {
                ...state,
                oem: action.payload
            }
        },
        resetSubscription: (state, action) => {
            return {
                planName: '',
                duration: 1,
                frequency: '',
                trialPeriod: 0,
                price: 0,
                oem: true
            }
        },
        setSubscription: (state, action) => {
            console.log(action.payload);
            return {
                planName: action.payload.planName || '',
                duration: action.payload.duration || 1,
                frequency: action.payload.frequency || '',
                trialPeriod: action.payload.trialPeriod || 0,
                price: Number(action.payload.price) / 100 || 0,
                oem: action.payload.oem || true
            }
        },

    }
})

export const { setPlanName, setDuration, setFrequency, setPrice, setTrialPeriod, setOem, resetSubscription, setSubscription } = SubscriptionDB.actions

export default SubscriptionDB.reducer
